import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DashboardT } from 'business/definitions';
import { trackEvent } from 'helpers/trackerHelpers';
import { RQAPICall } from 'store/APIClient';
import { useDispatch } from 'store/hooks';

const createFolder = async (
    name: string,
    key: number,
): Promise<{ message: string }> => {
    const response = await RQAPICall({
        endpoint: `explore/dashboard_folders`,
        body: { name, parent_folder_id: null, dashboards: [{ key }] }, // TODO: handle proper parent folder (in incoming PR)
        method: 'POST',
    });
    return response.content;
};

/**
 * RQ Mutation to create a dashboard folder.
 * The mutation takes as a parameter a name, which is the name of the new dashboard
 * folder, and a key corresponding to a dashboard id that should be added to the new folder.
 */
export const useCreateDashboardFolder = (dashboard: DashboardT) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    return useMutation({
        mutationFn: ({ name }: { name: string }) =>
            createFolder(name, dashboard.key),

        onSuccess: ({ message }) => {
            trackEvent('Move dashboard to a new folder', {
                dashboard: dashboard.slug,
            });
            dispatch.vision.notifyUser({
                message,
                snackType: 'success',
            });
            queryClient.invalidateQueries({
                queryKey: ['dashboard_folders'],
            });
        },
        meta: { useGlobalOnError: true },
    });
};
